import { useFlag } from '@calendly/feature-check-react'
import { useMemo } from 'react'

import { buildFilters } from 'components/meetings/filter_modal/utils'
import { useScope } from 'hooks/meetings/use_scope'

import { useLookupUuidsQuery } from '../api'
import { useSelectedView } from './use_selected_view'
import { allowedScopeTypes } from '../../../constants/meetings'
import { mapScopeTypeToBackendValue } from '../utils'

const useFilterParamsWithUuids = (filterParams) => {
  const { data: uuids } = useLookupUuidsQuery({ filters: filterParams })

  if (!uuids) {
    return null
  }

  return {
    ...filterParams,
    ...uuids,
  }
}

export const createUseResultsCount = (useGetMeetingsFilterCountQuery) => (filterParams, skip) => {
  const filtersToUse = useFilterParamsWithUuids(filterParams)
  const { scopeType, scopeId } = useScope()
  const selectedView = useSelectedView()
  const showNonOrganizerMeetings = useFlag('show_non_organizer_meetings')

  const filters = useMemo(
    () => (skip ? null : buildFilters(scopeType, scopeId, selectedView, filtersToUse, true, allowedScopeTypes, mapScopeTypeToBackendValue)),
    [skip, filtersToUse, scopeId, scopeType, selectedView]
  )

  const { data: searchData, isFetching: searchFetching } = useGetMeetingsFilterCountQuery(
    {
      forCount: true,
      ...filters,
      isOrganizer: !showNonOrganizerMeetings,
      includeNotetakerIneligibleExternalEvents: true,
    },
    { skip }
  )

  if (skip) {
    return {
      count: 0,
      isLoading: false
    }
  }

  return {
    count: searchData?.meetings?.total || 0,
    isLoading: searchFetching
  }
}
